/**
 * A utility function to get the current container for the portal.  For SSR, the
 * container will always be `null` since portals don't work server side.
 *
 * @param into - The element to portal into
 * @param intoId - An id for an element to portal into
 * @returns the portal container element or null
 */
export function getContainer(into, intoId) {
    if (typeof document === "undefined") {
        return null;
    }
    var container = null;
    if (typeof into === "undefined" && typeof intoId === "undefined") {
        container = document.body;
    }
    else if (typeof intoId === "string") {
        container = document.getElementById(intoId);
    }
    else if (typeof into === "string") {
        container = document.querySelector(into);
    }
    else if (typeof into === "function") {
        container = into();
    }
    else if (into) {
        container = into;
    }
    return container;
}
//# sourceMappingURL=getContainer.js.map